import { Box, HStack, Text, type BoxProps } from '@chakra-ui/react'
import type { ReactNode } from 'react'

type Variant = 'gray' | 'yellow' | 'blue' | 'green'

type Props = {
  label: string
  value: number | string
  icon: ReactNode
  variant?: Variant
} & BoxProps

const VARIANT = {
  gray: {
    iconBg: '#2F2F2F',
    svg: '/assets/img/Total%20Request%20Stat%20Card.svg',
  },
  yellow: {
    iconBg: '#E0B12C',
    svg: '/assets/img/In%20Progress%20Stat%20Card.svg',
  },
  blue: {
    iconBg: '#2B6FF3',
    svg: '/assets/img/Open%20Request%20Stat%20Card.svg',
  },
  green: {
    iconBg: '#18A957',
    svg: '/assets/img/Resolved%20Stat%20Card.svg',
  },
} satisfies Record<Variant, any>

export function StatCard({
  label,
  value,
  icon,
  variant = 'gray',
  ...rest
}: Props) {
  const v = VARIANT[variant]

  return (
    <Box
      position="relative"
      overflow="hidden"
      w="100%"
      maxW="316px"
      minW={0}
      h="94px"
      bg="transparent"
      border="0"
      borderRadius="0"
      {...rest}
    >
      {/* SVG is the actual card */}
      <Box
        position="absolute"
        inset={0}
        pointerEvents="none"
        bgImage={`url("${v.svg}")`}
        bgRepeat="no-repeat"
        bgPosition="center"
        bgSize="100% 100%"
      />

      {/* content (tune spacing to match figma) */}
      <HStack
        position="relative"
        zIndex={1}
        h="100%"
        px={6}
        spacing={4}
        align="center"
      >
        <Box
          w="40px"
          h="40px"
          borderRadius="full"
          bg={v.iconBg}
          color="white"
          display="flex"
          alignItems="center"
          justifyContent="center"
          flex="0 0 auto"
          fontSize="18px"
        >
          {icon}
        </Box>

        <Box lineHeight="1.1">
          <Text fontSize="sm" color="gray.600" fontWeight="500" mb="2px">
            {label}
          </Text>
          <Text fontSize="30px" fontWeight="800" color="gray.900">
            {value}
          </Text>
        </Box>
      </HStack>
    </Box>
  )
}

export default StatCard
